<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-26 17:16:24
 * @FilePath: /wemeet-admin-new/src/views/brand/components/editCategory.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form :model="form" :rules="rules">
      <el-form-item label="类目分组名称" prop="name">
        <el-input v-model="form.name" maxlength="5" placeholder="请输入，名称不可超过5个字符" />
      </el-form-item>
    </el-form>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">提交</el-button>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { parseTime } from '@/utils/index'
  import { addEnterpriseCategoryGroup, upDateEnterpriseCategoryGroup } from '@/api/enterPriseApi'
  export default defineComponent({
    name: 'EnterpriseListEdit',
    props: {
      groupId: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '30%',
        title: '',
        form: {
          name: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入角色名称' }],
        },
        checkUserList: [],
      })
      // 打开
      const handleOpen = async (row) => {
        if (row) {
          state.title = '编辑'
          state.form = Object.assign(state.form, row)
        } else {
          state.title = '新增'
        }
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const handleSave = async () => {
        try {
          state.form.groupId = props.groupId
          if (state.title === '新增') {
            await addEnterpriseCategoryGroup(state.form)
          } else {
            state.form.categoryGroupId = state.form.id
            await upDateEnterpriseCategoryGroup(state.form)
          }

          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          emit('fetch-data')
          handleClose()
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
          console.log(e)
        }
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const handleSelectionChange = (e) => {
        console.log(e)
        state.checkUserList = e
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleDate,
        handleSizeChange,
        handleCurrentChange,
        handleSelectionChange,
        handleSave,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
